import axios from 'axios';

import auth from '../libs/auth';
import { AxiosCache, AxiosCacheRequestConfig } from '../libs/AxiosCache';

export interface CourseType {
  id: string;
  ownerId: string;
  name: string;
  descriptionHeading: string;
  room: string;
  section: string;
  enrollmentCode?: string;
  teacherFolder?: { [key: string]: any };
  alternateLink: string;
  courseState: string;
  creationTime: string;
  updateTime: string;
  // id: string;
  fullname: string;
  shortname: string;
  timemodified: number;
}

class Course implements CourseType {
  id: string
  ownerId: string
  name: string
  descriptionHeading: string
  room: string
  section: string
  enrollmentCode?: string
  teacherFolder?: {[key: string]: any}
  alternateLink: string
  courseState: string
  creationTime: string
  updateTime: string
  fullname: string;
  shortname: string;
  timemodified: number;

  constructor(course: CourseType) {
    this.id = course.id;
    this.ownerId = course.ownerId;
    this.name = course.name;
    this.descriptionHeading = course.descriptionHeading;
    this.room = course.room;
    this.section = course.section;
    this.enrollmentCode = course.enrollmentCode;
    this.teacherFolder = course.teacherFolder;
    this.alternateLink = course.alternateLink;
    this.courseState = course.courseState;
    this.creationTime = course.creationTime;
    this.updateTime = course.updateTime;
    this.fullname = course.fullname;
    this.shortname = course.shortname;
    this.timemodified = course.timemodified;
  }

  static async findById(query: { [key: string]: any } = {}, config?: AxiosCacheRequestConfig): Promise<Course> {
    const session = auth.getSession();
    const { data } = await axios.post('/student/get-course', {...query, token: session?.accessToken});
    return new Course(data[0]);
  }

  static async getCourses(query: { [key: string]: any } = {}, config?: AxiosCacheRequestConfig): Promise<Course[]> {
    const session = auth.getSession();
    const { data = [] } = await axios.get('/classroom/courses', AxiosCache.getConfig({
      ...config, params: {
        token: session?.accessToken
      }
    }));
    return (data as CourseType[]).map(item => new Course(item));
  }
  
  static async getMoodleCourses(query: { [key: string]: any } = {}, config?: AxiosCacheRequestConfig): Promise<Course[]> {
    const { data = [] } = await axios.post('/student/get-courses', query);

    return (data as CourseType[]).map(item => new Course({...item, id: item.id.toString()}));
  }

  static getListUrlPath(role: string) {
    return `/${role}/courses`;
  }
}

export default Course;
